import { Route } from 'react-router-dom';
import { ManageMip } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageMip/ManageMip';
import { ManageDeal } from '@dealstack/frontend/admin/pages/Manage/MIP/ManageDeal/ManageDeal';
import { ListMip } from '@dealstack/frontend/admin/pages/Manage/MIP/ListMip/ListMip';
import { SentryRoutes } from '@dealstack/frontend/shared/sentry.ts';

export enum MANAGE_MIP_ROUTES {
	MIP = '/mip/:mipId',
	DEAL = '/deal/:dealId',
}

export const ManageMipRoutes = () => {
	return (
		<div style={{ margin: '2rem' }}>
			<SentryRoutes>
				<Route path={`${MANAGE_MIP_ROUTES.MIP}`} element={<ManageMip />} />
				<Route path={`${MANAGE_MIP_ROUTES.DEAL}`} element={<ManageDeal />} />
				<Route path="*" element={<ListMip />} />
			</SentryRoutes>
		</div>
	);
};
